export default __webpack_public_path__ + "static/media/bottom-edge-star.300fbf06.svg";